<ng-container>
    <p-table selectionMode="single" [value]="schoolDocuments">
        <ng-template pTemplate="header">
            <tr>
                <th [style]="{width: '80px'}">
                    ID
                </th>
                <th>
                    Name
                </th>
                <th>
                    Description
                </th>
                <th>
                    Delete
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-file>
            <tr [pSelectableRow]="file">
                <td>
                    {{file.id}}
                </td>
                <td>
                    <a (click)="downloadFile(file)">
                        {{file.name}}
                    </a>
                </td>
                <td>
                    {{file.description}}
                </td>
                <td>
                    <p-button styleClass="p-button-danger" icon="pi pi-trash"></p-button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</ng-container>
<p-accordion [(activeIndex)]="accordionIndex">
    <p-accordionTab header="Upload a file">
        <p-fileUpload #form [customUpload]="true" (uploadHandler)="uploadFile($event.files, form)" [maxFileSize]="16000000">
        </p-fileUpload>
        <p>
            <strong>
                Note :
            </strong>
            the server does not accept a file larger than 15 MB.
        </p>
    </p-accordionTab>
</p-accordion>